// extracted by mini-css-extract-plugin
module.exports = {"error":"error-message__error___2FFmY"};